import moment from 'moment'

export const customerComplaintInvestigation = {
  id: '',
  distributedToInternal: moment().format('YYYY-MM-DD'),
  receivedDate: moment().format('YYYY-MM-DD'),
  reportedDate: moment().format('YYYY-MM-DD'),
  customerId: '',
  customerName: '',
  address: '',
  pic: '',
  email: '',
  brandId: '',
  brandName: '',
  productId: '',
  productName: '',
  phone: '',
  plantId: '',
  plantName: '',
  packagingId: '',
  packagingName: '',
  blDate: moment().format('YYYY-MM-DD'),
  dispatchDate : moment().format('YYYY-MM-DD'),
  dischargePort : '',
  countryId: '',
  countryName: '',
  containerNo: '',
  modelOfDeliveryId: '',
  modelOfDeliveryName: '',
  conformanceTypeId: '',
  conformanceTypeName: '',
  complaintMediaId: '',
  complaintMediaName: '',
  enclosedId: '',
  enclosedName: '',
  description: '',
  createdBy: '',
  updatedBy: '',
  ccSalesAttachment: '',
  createdAt: moment().format('YYYY-MM-DD'),
  updatedAt: moment().format('YYYY-MM-DD'),
}

export const customerComplaintDetail = {
  customerComplaintId: '',
  po: '',
  so: '',
  batch: '',
  qty: 0,
}

export const customerComplaintInvestigationDetail = {
  id: '',
  customerComplaintId: '',
  question: '',
  memberId: '',
  responder: '',
  email: '',
  attachment: '',
  answeredAt: '',
}

export const customerComplaintChooseOwner = {
  id: '',
  distributedToInternal: moment().format('YYYY-MM-DD'),
  receivedDate: moment().format('YYYY-MM-DD'),
  reportedDate: moment().format('YYYY-MM-DD'),
  customerId: '',
  customerName: '',
  address: '',
  pic: '',
  email: '',
  brandId: '',
  brandName: '',
  productId: '',
  productName: '',
  phone: '',
  plantId: '',
  plantName: '',
  packagingId: '',
  packagingName: '',
  po: '',
  so: '',
  batch: '',
  qty: 0,
  blDate: moment().format('YYYY-MM-DD'),
  dispatchDate : moment().format('YYYY-MM-DD'),
  dischargePort : '',
  countryId: '',
  countryName: '',
  containerNo: '',
  modelOfDeliveryId: '',
  modelOfDeliveryName: '',
  conformanceTypeId: '',
  conformanceTypeName: '',
  complaintMediaId: '',
  complaintMediaName: '',
  enclosedId: '',
  enclosedName: '',
  description: '',
  ownerMemberId: '',
  ownerMemberName: '',
  ownerMemberEmail: '',
  happenedBefore: false,
  createdBy: '',
  updatedBy: '',
  ccSalesAttachment: '',
  ccAreaOwnerAttachment: '',
  createdAt: moment().format('YYYY-MM-DD'),
  updatedAt: moment().format('YYYY-MM-DD'),
}

export const customerComplaintChooseOwnerDetail = {
  id: '',
  customerComplaintId: '',
  question: '',
  memberId: '',
  responder: '',
  email: '',
  attachment: '',
  answeredAt: '',
}